
import React from 'react';
import styled from 'styled-components';

const StyledMapIFrame = styled.iframe`
  min-height: 300px;
  border: 0;
  margin-top: ${({ marginTop }) => marginTop || 0};

  @media (min-width: 768px) {
    min-height: 400px;
  }
`;

export const PoliclinicoMapComponent = ({ marginTop }) => (
  <div className="d-flex flex-column">
    <StyledMapIFrame
      allowfullscreen
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2975.664315487204!2d12.465919815408228!3d41.77089478009538!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13258c8e29ca631b%3A0xd72305b0a9a265e0!2sPoliclinico+Universitario+Campus+Bio-Medico!5e0!3m2!1sit!2sit!4v1525358620788"
      frameborder="0"
      className="w-100 position-relative h-auto"
      marginTop={marginTop}
    ></StyledMapIFrame>
  </div>
);